export default __webpack_public_path__ + "static/media/fuzzing-trimmed-linux.a954ae38.avif";